<template>
  <div class="wrapper">
    <p v-if="cashflows.length<=0 && showLoading===false" class="center" style="margin-top:12px;font-size: 14px;">暂无记录</p>
    <SheetItem
      v-for="item in cashflows"
      v-else
      :key="item.cashflowId"
      :month="item.month"
      :company-name="item.companyName"
      :to="`/cashflow-detail/${item.cashflowId}`"/>
  </div>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex';
  import SheetItem from '../../components/SheetItem';

  export default {
    name: "Cashflows",
    components: {
      SheetItem
    },
    computed: {
      ...mapGetters(['cashflows','showLoading'])
    },
    methods: {
      ...mapActions(['getCashflows'])
    },
    created() {
      window.document.title = '现金流量表';
      this.getCashflows();
    }
  }
</script>

<style scoped>

</style>